import GridModel from './gridmodel';
import formatDate from '../utils/formatdate';

const VideoModel = GridModel.extend({
  idAttribute: 'videoID',
  initialize() {
    GridModel.prototype.initialize.call(this);
    this.set({ publishDate: formatDate(this.get('publishDate')) });
  }
});

export default VideoModel;
